import axios from 'axios';
import types from './mutations-types';

const actions = {
  async setAllActions({ commit }, obj) {
    const res = await axios.get(
      `${process.env.API_ROOT}/actions/${obj.companyId}`,
      {
        headers: {
          'x-access-token': obj.token,
        },
      },
    );

    commit(types.SET_ALL_ACTIONS, res.data);
  },

  async setSelectedTreatment({ commit }, value) {
    commit(types.SET_SELECTED_TREATMENT, value);
  },

  async setAnswers({ commit }, obj) {
    const resp = await axios.get(
      `${process.env.API_ROOT}/answers/${obj.companyId}`,
      {
        headers: {
          'x-access-token': obj.token,
        },
        params: { ...obj.queryParams },
      },
    );

    commit(types.SET_ANSWER, resp.data);
  },

  async setAnswersRevision({ commit }, obj) {
    const resp = await axios.get(
      `${process.env.API_ROOT}/treatments-revisions`,
      {
        headers: {
          'x-access-token': obj.token,
        },
        params: { ...obj.queryParams },
      },
    );

    commit(types.SET_ANSWER_REVISION, resp.data);
  },

  async setOneAnswer({ commit }, obj) {
    const resp = await axios.get(
      `${process.env.API_ROOT}/answer/${obj.companyId}/${obj.answerId}`,
      {
        headers: {
          'x-access-token': obj.token,
        },
      },
    );

    commit(types.SET_ONE_ANSWER, resp.data);
  },

  async setCostumerNotifications({ commit }, obj) {
    const { data } = await axios.get(
      `${process.env.API_ROOT}/treatments/notifications/${obj.companyId}/${obj.answerId}`,
      {
        headers: {
          'x-access-token': obj.token,
        },
        params: {
          optionSelected: obj.optionValue,
          order: obj.order,
        },
      },
    );

    commit(types.SET_COSTUMER_NOTIFICATIONS, data);
  },

  async addCategory({ commit }, obj) {
    await axios.post(
      `${process.env.API_ROOT}/treatments/categories/${obj.id}`,
      {
        ...obj.data,
      },
      {
        headers: {
          'x-access-token': obj.token,
        },
      },
    );
  },

  async deleteCategory({ commit }, obj) {
    await axios.delete(
      `${process.env.API_ROOT}/treatments/categories/${obj.id}`,
      {
        headers: {
          'x-access-token': obj.token,
        },
        data: {
          ...obj.data,
        },
      },
    );
  },

  async addComment({ commit }, obj) {
    const { data: notifications } = await axios.put(
      `${process.env.API_ROOT}/treatments/comment/${obj.answerId}`,
      { ...obj.data },
      { headers: { 'x-access-token': obj.token } },
    );

    commit(types.SET_COSTUMER_NOTIFICATIONS, notifications);
  },

  async updateStatus({ commit }, obj) {
    await axios.put(
      `${process.env.API_ROOT}/treatments/status/${obj.answerId}`,
      {
        ...obj.data,
      },
      {
        headers: {
          'x-access-token': obj.token,
        },
      },
    );
  },

  async updateStatusSinqia({ commit }, obj) {
    await axios.put(
      `${process.env.API_ROOT}/treatments/status/sinqia/${obj.answerId}`,
      {
        ...obj.data,
      },
      {
        headers: {
          'x-access-token': obj.token,
        },
      },
    );
  },

  async updateEnableMonitor({ commit }, obj) {
    await axios.put(
      `${process.env.API_ROOT}/treatments/monitor/${obj.answerId}`,
      {
        ...obj.data,
      },
      {
        headers: {
          'x-access-token': obj.token,
        },
      },
    );
  },

  async updateResponsible({ commit }, obj) {
    await axios.put(
      `${process.env.API_ROOT}/treatments/responsible/${obj.answerId}`,
      {
        ...obj.data,
      },
      {
        headers: {
          'x-access-token': obj.token,
        },
      },
    );
  },

  async editCommentAnswer({ commit }, obj) {
    await axios.put(
      `${process.env.API_ROOT}/answer/${obj.answerId}`,
      {
        ...obj.data,
      },
      {
        headers: {
          'x-access-token': obj.token,
        },
      },
    );
  },

  async disableAnswer({ commit }, obj) {
    await axios.post(
      `${process.env.API_ROOT}/recyclebins/${obj.companyId}`,
      { ...obj.data },
      {
        headers: {
          'x-access-token': obj.token,
        },
      },
    );
  },
};

export default actions;



// WEBPACK FOOTER //
// ./src/store/modules/treatments/actions.js